import {
  findCountryMappingByIsdCode,
  findCountryMappingByTimezoneId,
  getCountryTimezoneOptions,
} from "./signup";

/** Set false to restore UAE country, timezone, and content headers on both platforms. */
export const USE_INDIA_EXPERIENCE_FOR_UAE: boolean = true;

/** Build content headers synchronously, including before country bootstrap finishes. */
export function getContentCountryCode(
  countryCode: string | null | undefined,
  accountIsdCode: string | null | undefined,
  useIndiaExperienceForUae: boolean = USE_INDIA_EXPERIENCE_FOR_UAE,
): string | null {
  const code = countryCode?.trim().toUpperCase();
  const isUae =
    accountIsdCode?.replace(/\D/g, "") === "971" ||
    code === "AE" ||
    code === "ARE";
  if (isUae) return useIndiaExperienceForUae ? "IND" : "ARE";
  if (code === "IN") return "IND";
  if (code === "US") return "USA";
  return code || null;
}

/** Temporary experience routing only; keep the profile's real ISD unchanged. */
export function getExperienceIsdCode(
  isdCode: string | null | undefined,
  useIndiaExperienceForUae: boolean = USE_INDIA_EXPERIENCE_FOR_UAE,
) {
  const useIndia = useIndiaExperienceForUae;
  return useIndia && isdCode?.replace(/\D/g, "") === "971" ? "+91" : isdCode;
}

export function resolveCountryExperience(
  mappings: unknown,
  accountIsdCode: string | null | undefined,
  timezoneId: number | null | undefined,
  useIndiaExperienceForUae: boolean = USE_INDIA_EXPERIENCE_FOR_UAE,
) {
  const experienceIsd = getExperienceIsdCode(
    accountIsdCode,
    useIndiaExperienceForUae,
  );
  const byIsd = findCountryMappingByIsdCode(mappings, experienceIsd);
  const byTimezone = findCountryMappingByTimezoneId(mappings, timezoneId);
  const timezoneMatchesIsd =
    byTimezone &&
    findCountryMappingByIsdCode({ items: [byTimezone] }, experienceIsd);
  const country = timezoneMatchesIsd ? byTimezone : (byIsd ?? byTimezone);
  const options = getCountryTimezoneOptions(country);
  const selectedTimezoneId = options.some((option) => option.id === timezoneId)
    ? (timezoneId ?? undefined)
    : options.length === 1
      ? options[0].id
      : undefined;
  return { country, selectedTimezoneId };
}
